import type { ICellRendererParams } from "ag-grid-community";
import { IconArrowDownChevronSmall, IconArrowRight } from "@synthesis/shared-icons";

import type { ConstructorDocumentKit } from "../constructor-documents-page.lib";

/** Ячейка-стрелка раскрытия строки комплекта: разворачивает/сворачивает detail-панель (master/detail AG Grid). */
export const DocumentKitExpandCell = (params: ICellRendererParams<ConstructorDocumentKit>) => {
  const { node, api, data } = params;

  if (!node || !data?.expanded) {
    return null;
  }

  const expanded = Boolean(node.expanded);

  return (
    <button
      type="button"
      aria-label={expanded ? "Свернуть документы комплекта" : "Развернуть документы комплекта"}
      aria-expanded={expanded}
      className="text-neutrals-60 hover:text-type-common hover:bg-neutrals-95/80 inline-flex size-8 items-center justify-center rounded-lg transition-colors"
      onClick={(event) => {
        event.stopPropagation();
        node.setExpanded(!expanded);
        api.refreshCells({ rowNodes: [node], force: true });
      }}
    >
      {expanded ? <IconArrowDownChevronSmall className="size-5" /> : <IconArrowRight className="size-5" />}
    </button>
  );
};
